import { DIV_DEPT_LEADER_LIST, DIV_DEPT_LIST, DIV_LIST } from "shared/constants/ActionTypes";

const initialState = {
    divList: [],
    deptList: [],
    leaderList: [],
};

const penomoranReducer = (state=initialState,action) => {
    switch (action.type) {
        case DIV_LIST:
            return {
                ...state,
                divList: action.payload
            }
            
        case DIV_DEPT_LIST:
            return {
                ...state,
                deptList:action.payload
            }
        
        case DIV_DEPT_LEADER_LIST:
            return {
                ...state,
                leaderList:action.payload
            }
            
        default:
            return {
                ...state
            }
    }
};

export default penomoranReducer;